/**
 * Messaggio da mostrare in redazione quando la formattazione automatica non va
 * a buon fine.
 *
 * Il caso che ci ha fatto perdere piu' tempo e' quello in cui il backend
 * risponde 200 con il testo formattato ma il pannello non lo riceve: davanti al
 * dominio c'e' Cloudflare, che chiude la richiesta dopo 100 secondi con un 524.
 * Il body di quella risposta e' una pagina HTML, quindi non contiene alcun
 * `messaggio` e la redazione vedeva solo "Formattazione non riuscita", senza
 * capire che il problema era l'attesa.
 */
export function messaggioErroreFormattazione(err: any): string {
  const dalBackend = err?.error?.messaggio;
  if (typeof dalBackend === 'string' && dalBackend.trim().length > 0) {
    return dalBackend;
  }
  // status 0: richiesta interrotta senza risposta; 408/504/524: tempo scaduto
  // lungo la catena browser -> Cloudflare -> Apache.
  if ([0, 408, 502, 504, 524].includes(err?.status)) {
    return 'La formattazione ha richiesto troppo tempo e la richiesta e\' scaduta. Riprova, oppure formatta l\'articolo in due parti.';
  }
  return 'Formattazione non riuscita. Riprova.';
}
